// extracted by mini-css-extract-plugin
export var active = "_dq-2";
export var recordingDot = "_dq-1";
export var recordingIndicator = "_dq-0";